<template>
  <div class="">
    <div @click.self="$emit('cancel')" class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg shadow-sm border border-gray-100 p-16">

      <div class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3">
        <button
            type="button"
            class="w-full flex items-center justify-between px-4 py-3 bg-gray-50 border-b"
            @click="togglePanel('basic')"
        >
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">اطلاعات پایه متغیر</h2>
          </div>
          <Chevron :open="isOpen('basic')"/>
        </button>

        <div v-show="isOpen('basic')" class="p-4">

          <div class="grid grid-cols-7 gap-4">
            <div class="col-span-1 space-y-1">
              <label class="block text-[12px] font-medium text-gray-700 mb-2">تصویر اصلی</label>

              <smart-image-picker-modal
                  :accept="'image/*'"
                  :max-size-m-b="10"
                  :hint="'حداکثر ۱۰MB'"
                  :value="(form.image && typeof form.image === 'object') ? form.image : null"
                  :current-preview-url="(form.image && typeof form.image === 'string') ? image_source(form.image) : ''"
                  @input="onVariationImageChange"
              />

              <!-- دکمه حذف فقط وقتی عکس وجود داره -->
              <button
                  v-if="form.image"
                  type="button"
                  @click="removeVariationImage"
                  class="mt-2 w-full text-[11px] px-2 py-1 rounded bg-white/90 border border-gray-300 text-red-600 hover:bg-red-50"
              >
                حذف تصویر
              </button>
            </div>

            <div class="col-span-3 space-y-1">
              <Label required>نام</Label>
              <input
                  v-model="form.name"
                  type="text"
                  class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"
              >
            </div>

            <!-- SKU -->
            <div class="col-span-3 space-y-1">
              <Label required>کد SKU</Label>
              <input
                  v-model="form.sixteen_digit_code"
                  type="text"
                  class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3">
        <button
            type="button"
            class="w-full flex items-center justify-between px-4 py-3 bg-gray-50 border-b"
            @click="togglePanel('attributes')"
        >
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-purple-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4M7 12a5 5 0 0110 0 5 5 0 01-10 0z"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">
              خواص و ویژگی‌ها
            </h2>
          </div>
          <Chevron :open="isOpen('attributes')"/>
        </button>

        <div v-show="isOpen('attributes')" class="p-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="space-y-1">
              <category-tree-select
                  v-model="form.avails"
                  :categories="availsOptions"
                  api-url="product/avails"
                  label="خواص"
              />
            </div>

            <div class="space-y-1">
              <category-tree-select
                  v-model="form.feature"
                  :categories="featuresOptions"
                  api-url="product/feature"
                  label="ویژگی‌ها "
              />
            </div>
          </div>
        </div>
      </div>

      <div
          v-if="form.id && user.user_type == 'ma'"
          class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3"
      >
        <button type="button"
                class="w-full flex items-center justify-between px-3 sm:px-4 py-3 bg-gray-50 border-b"
                @click="togglePanel('pricing')">
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586l6 6V19a2 2 0 01-2 2z"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">
              قیمت‌گذاری
            </h2>
          </div>
          <Chevron :open="isOpen('pricing')"/>
        </button>

        <div v-show="isOpen('pricing')" class="p-4">
          <div class="grid grid-cols-1 md:grid-cols-6 gap-6 mt-3">
            <div class="md:col-span-2" v-if="currency.id == 19">
              <cleave-money
                  :required="true"
                  label="قیمت مصرف کننده"
                  v-model="form.regular_price"
                  currency-unit="تومان"
                  @input="markPricingDirty"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-6 gap-6 mt-3">
            <div class="md:col-span-2">
              <cleave-money
                  :rate="currency.exchange_rate_to_toman"
                  :required="true"
                  label="قیمت پایه"
                  v-model="form.base_price"
                  :currency-unit="currency.name"
                  :label-down-value="base_price_with_rate"
                  label-down="برابر با "
                  @input="markPricingDirty"
              />
            </div>
            <div class="md:col-span-2">
              <cleave-money
                  :required="true"
                  label="هزینه ارسال"
                  v-model="form.shipping_cost"
                  :currency-unit="currency.name"
                  :label-down-value="shipping_cost_with_rate"
                  label-down="برابر با "
                  @input="markPricingDirty"
              />
            </div>
            <div class="md:col-span-2">
              <cleave-money
                  disabled="true"
                  label="مبلغ پایه با احتساب هزینه ارسال"
                  v-model="form.shipping_cost + form.base_price"
                  :currency-unit="currency.name"
                  :label-down-value="shipping_cost_with_rate + base_price_with_rate"
                  label-down="برابر با "
                  @input="markPricingDirty"
              />
            </div>

            <div class="md:col-span-1">
              <label class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نوع حاشیه سود
              </label>
              <select
                  v-model="form.profit_type"
                  class="select-input w-full"
                  @change="markPricingDirty"
              >
                <option value="percent">درصد</option>
                <option value="amount">مبلغ</option>
              </select>
            </div>

            <div class="md:col-span-1">
              <label class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                حاشیه سود
                <span class="text-[7px] mr-1 ml-1">برابر</span>
                {{ profit_sum | toMoney }}
                <span class="text-[7px] mr-1">تومان</span>
              </label>

              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.profit_margin"
                    type="number"
                    min="0"
                    class="w-full px-3 py-2 rounded-md border border-gray-300
                         focus:outline-none focus:ring-2 focus:ring-blue-500
                         text-[13px] text-center bg-blue-50/80"
                    @input="markPricingDirty"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-[8px] text-gray-500" v-if="form.profit_type === 'amount'">تومان</span>
                  <span class="text-[8px] text-gray-500" v-else>درصد</span>
                </div>
              </div>

              <label class="block text-[8px] mb-1 pt-2 flex items-center">
                مبلغ با حاشیه سود
                ( {{ (profit_sum + base_price_with_rate + shipping_cost_with_rate) | toMoney }} تومان )
              </label>
            </div>

            <div class="md:col-span-1">
              <label class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نوع تخفیف
              </label>
              <select
                  v-model="form.discount_type"
                  class="select-input w-full"
                  @change="markPricingDirty"
              >
                <option value="percent">درصد</option>
                <option value="amount">مبلغ</option>
              </select>
            </div>

            <div class="md:col-span-1">
              <label class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                مقدار تخفیف
                {{ discount_sum | toMoney }}
                <span class="text-[7px] mr-1">تومان</span>
              </label>

              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.discount_margin"
                    type="number"
                    min="0"
                    class="w-full px-3 py-2 rounded-md border border-gray-300
                         focus:outline-none focus:ring-2 focus:ring-blue-500
                         text-[13px] text-center bg-blue-50/80"
                    @input="markPricingDirty"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-[8px] text-gray-500" v-if="form.discount_type === 'amount'">تومان</span>
                  <span class="text-[8px] text-gray-500" v-else>درصد</span>
                </div>
              </div>
            </div>

            <div class="md:col-span-2">
              <cleave-money
                  :required="true"
                  label="قیمت نهایی فروش"
                  v-model="final_amount_local"
                  currency-unit="تومان"
                  :disabled="true"
              />
            </div>
          </div>
          <div class="flex justify-end mt-6">
            <button
                type="button"
                :class="pricingButtonClass"
                :disabled="pricingSaving || !pricingDirty"
                @click="savePricing"
            >
              <span  :class="pricingDirty? 'text-gray-50' : 'text-green-800'">{{ pricingButtonText }}</span>
            </button>
          </div>

        </div>
      </div>

      <div
          v-if="form.id && user.user_type == 'ma'"
          class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3"
      >
        <button type="button"
                class="w-full flex items-center justify-between px-3 sm:px-4 py-3 bg-gray-50 border-b"
                @click="togglePanel('inventory')">
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-yellow-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8-4-8 4v10l8 4 8-4V7z"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">موجودی انبار</h2>
          </div>

          <div class="ml-4">
            <span class="inline-flex gap-1 px-3 py-1.5 rounded-lg text-xs font-medium
                          bg-gradient-to-r from-indigo-600 to-blue-600 text-white shadow-sm">
              <svg class="w-3.5 h-3.5 text-white opacity-80" fill="none" stroke="currentColor" stroke-width="2"
                   viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M20 7l-8-4-8 4v10l8 4 8-4V7z"/>
              </svg>
              <span>موجودی کل:</span>
              <b class="font-extrabold text-white">{{ total_inventory | toMoney }}</b>
            </span>
          </div>

          <Chevron :open="isOpen('inventory')"/>
        </button>

        <div v-show="isOpen('inventory')" class="p-4">
          <div class="flex items-center justify-between mb-3">
            <div class="col-span-1" v-show="false">
              <cleave-money
                  :required="false"
                  label="حداقل موجودی"
                  v-model="form.packing_inventory.minimum_inventory"
                  currency-unit="عدد"
                  @input="markInventoryDirty"
              />
            </div>

            <button
                v-if="!has_new_inventory_row"
                @click="addInventoryRow"
                type="button"
                class="px-3 py-1.5 rounded-md bg-blue-600 text-xs hover:bg-blue-700 text-gray-50"
            >
              <span class="text-gray-50">افزودن موجودی انبار جدید</span>
            </button>
          </div>

          <div class="rounded-lg border border-gray-200 overflow-hidden">
            <table class="min-w-full text-xs">
              <thead class="bg-gray-50 text-gray-600">
              <tr>
                <th class="px-3 py-2 text-right">انبار</th>
                <th class="px-3 py-2 text-right">موجودی</th>
                <th class="px-3 py-2 text-right w-28"></th>
              </tr>
              </thead>

              <tbody>
              <tr v-if="inventoriesLoading">
                <td colspan="3" class="px-3 py-6 text-center text-gray-500">در حال بارگذاری...</td>
              </tr>

              <tr v-for="(row, idx) in inventories" :key="row._key" class="border-t">
                <td class="px-3 py-2">
                  <div v-if="row._isNew" class="flex items-center gap-2">
                    <store-select
                        v-model="new_store_for_inventory"
                        :not_in="inventory_store_ids"
                        @input="markInventoryDirty"
                    />
                  </div>

                  <div v-else class="text-gray-800">
                    {{ row.store_name || ('انبار #' + row.store) }}
                  </div>
                </td>

                <td class="px-3 py-2">
                  <input
                      type="number"
                      min="0"
                      class="w-32 px-2 py-1 rounded border border-gray-300
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           text-[12px] text-center bg-blue-50/80"
                      v-model.number="row._inventoryDraft"
                      @input="markInventoryDirtyRow(row)"
                  />
                </td>

                <td class="px-3 py-2">
                  <div class="flex items-center gap-2">
                    <button
                        :class="inventoryRowButtonClass(row)"
                        :disabled="row._saving || !row._dirty"
                        @click="saveInventoryRow(row)"
                        title="ذخیره‌ی این ردیف"
                    >
                      {{inventoryRowButtonText(row)}}
                    </button>

                    <button
                        v-if="row._isNew"
                        class="px-2 py-1 rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
                        @click="removeNewRow(row)"
                        title="لغو ردیف جدید"
                    >
                      لغو
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="!inventoriesLoading && !inventories.length">
                <td colspan="3" class="px-3 py-6 text-center text-gray-500">
                  برای این متغیر هنوز موجودی ثبت نشده
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <section class="bg-white rounded-xl border border-gray-200 p-4 mb-3">
        <h2 class="text-sm font-semibold text-gray-800 mb-4">تنظیمات رنگ تست مجازی رژلب</h2>
        <div class="mb-3">
          <label class="block">کد رنگ تست مجازی رژلب (اختیاری)</label>
          <input v-model="form.try_on_color_hex" dir="ltr" maxlength="7" placeholder="#BE536A" class="border rounded px-3 py-2" />
          <span :style="{backgroundColor: /^#[0-9a-f]{6}$/i.test(form.try_on_color_hex) ? form.try_on_color_hex : 'transparent', display: 'inline-block', width: '28px', height: '28px', border: '1px solid #ccc', verticalAlign: 'middle'}"></span>
          <p v-if="form.try_on_color_hex && !/^#[0-9a-f]{6}$/i.test(form.try_on_color_hex)" class="text-red-600">کد رنگ باید به شکل #RRGGBB باشد.</p>
          <div class="flex flex-wrap gap-3 mt-3">
            <label class="block">شدت اولیه
              <input v-model.number="form.try_on_opacity" type="number" min="0" max="1" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
            </label>
            <label class="block">پوشانندگی
              <input v-model.number="form.try_on_coverage" type="number" min="0" max="1" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
            </label>
            <label class="block">روشنایی رنگ
              <input v-model.number="form.try_on_brightness" type="number" min="0.5" max="1.5" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
            </label>
          </div>
          <p class="text-sm text-gray-500 mt-2">تنظیم هر تنوع مستقل است. برای کالیبراسیون، نتیجه را با نمونه واقعی در نور ثابت و روی لب روشن و تیره مقایسه کنید؛ نمایش همچنان تقریبی است.</p>
        </div>
      </section>
      <div
               class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3">
        <button type="button" class="w-full flex items-center justify-between px-3 sm:px-4 py-3 bg-gray-50 border-b"
                @click="togglePanel('details')">
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-pink-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">جزئیات کالا</h2>
          </div>
          <Chevron :open="isOpen('details')"/>
        </button>

        <div v-show="isOpen('details')" class="p-4">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div class="space-y-1">
              <Label>ستون قفسه</Label>
              <input v-model="form.shelf_number"
                     class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"/>
            </div>
            <div class="space-y-1">
              <Label>ردیف قفسه</Label>
              <input v-model="form.aisle"
                     class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"/>
            </div>
            <div class="space-y-1">
              <Label>تاریخ تولید</Label>
              <date-field
                  class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"
                  v-model="form.product_date"/>
            </div>
            <div class="space-y-1">
              <Label>تاریخ انقضا</Label>
              <date-field
                  class="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[10px] text-center bg-blue-50/80"
                  v-model="form.expired_date"/>
            </div>
            <div class="space-y-1">
              <button
                  @click="openLabel(form.id, 'html')"
                  class="w-full text-right px-4 py-3 rounded-md bg-blue-50 hover:bg-blue-100 flex items-center gap-3 transition-colors duration-150"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clip-rule="evenodd" />
                </svg>
                <span>پرینت بارکد</span>
              </button>
            </div>
            <div class="space-y-1">
              <button
                  @click="openLabel(form.id, 'html_download')"
                  class="w-full text-right px-4 py-3 rounded-md bg-blue-50 hover:bg-blue-100 flex items-center gap-3 transition-colors duration-150"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
                <span>دانلود بارکد </span>
              </button>
            </div>
            <div class="space-y-1">
              <button
                  @click="openQr(form.id, 'html')"
                  class="w-full text-right px-4 py-3 rounded-md bg-blue-50 hover:bg-blue-100 flex items-center gap-3 transition-colors duration-150"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-purple-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clip-rule="evenodd" />
                  <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
                </svg>
                <span>پرینت QRCode</span>
              </button>
            </div>
            <div class="space-y-1">
              <button
                  @click="openQr(form.id, 'html_download')"
                  class="w-full text-right px-4 py-3 rounded-md bg-blue-50 hover:bg-blue-100 flex items-center gap-3 transition-colors duration-150"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-orange-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
                <span>دانلود QRCode</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="form.product_type!='variable'"
               class="bg-white rounded-xl border border-gray-200 overflow-hidden mb-3">
        <button type="button" class="w-full flex items-center justify-between px-3 sm:px-4 py-3 bg-gray-50 border-b"
                @click="togglePanel('shipping')">
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-blue-700" viewBox="0 0 24 24" fill="none" stroke="#00264d">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
            </svg>
            <h2 class="text-sm font-semibold text-gray-800">اطلاعات پستی</h2>
          </div>
          <Chevron :open="isOpen('shipping')"/>
        </button>

        <div v-show="isOpen('shipping')" class="p-4">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div class="space-y-1">
              <cleave-money
                  :required="false"
                  label="وزن"
                  v-model="form.postal_weight"
                  currency-unit="گرم"
              ></cleave-money>
            </div>

            <div class="space-y-1">
              <cleave-money
                  :required="false"
                  label="طول"
                  v-model="form.length"
                  currency-unit="سانت"
              ></cleave-money>
            </div>

            <div class="space-y-1">
              <cleave-money
                  :required="false"
                  label="عرض"
                  v-model="form.width"
                  currency-unit="سانت"
              ></cleave-money>
            </div>

            <div class="space-y-1">
              <cleave-money
                  :required="false"
                  label="ارتفاع"
                  v-model="form.height"
                  currency-unit="سانت"
              ></cleave-money>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-4 pt-6">
        <button @click="$emit('cancel')" v-if="form.id"
                class="px-4 py-2 rounded-md text-center bg-red-800 text-white text-sm">
          <span class="text-gray-50">بازگشت</span>

        </button>
        <button
            type="button"
            @click="saveVariationCore"
            class="px-4 py-2 rounded-md bg-blue-600 text-center hover:bg-blue-700 text-white text-sm"
        >
          <span class="text-gray-50">{{ form.id ? 'ذخیره ' : 'ایجاد متغیر جدید' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { appendTryOnCalibration, validTryOnCalibration, tryOnCalibrationFrom } from "./tryOnCalibration";
import DateField from "@/components/mcomponents/cleave/DateField";
import StoreSelect from "@/components/selects/StoreSelect";
import CleaveMoney from "@/components/mcomponents/cleave/Money";
import CategoryTreeSelect from "@/modules/product_admin/CategoryTreeSelect";
import SmartImagePickerModal from "@/components/scomponents/SmartImagePicker";

export default {
  name: 'AdminVariationForm',

  components: {
    SmartImagePickerModal,
    CleaveMoney,
    StoreSelect,
    CategoryTreeSelect,
    DateField,
    Chevron: {
      functional: true,
      props: { open: Boolean },
      render(h, { props }) {
        return h('svg', {
          class: 'h-4 w-4 text-gray-500 transition-transform ' + (props.open ? 'rotate-180' : ''),
          attrs: { viewBox: '0 0 20 20', fill: 'currentColor' }
        }, [h('path', {
          attrs: {
            'fill-rule': 'evenodd',
            d: 'M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.24 4.25a.75.75 0 01-1.08 0l-4.24-4.25a.75.75 0 01.02-1.06z',
            'clip-rule': 'evenodd'
          }
        })])
      }
    },
    Label: {
      functional: true,
      render(h, ctx) {
        const required = ctx.data && ctx.data.attrs && ctx.data.attrs.required
        return h('label', { class: 'block text-[12px] font-medium text-gray-700 mb-1' }, [
          required ? h('span', { class: 'text-rose-500 ml-1' }, '*') : null,
          ...ctx.children
        ])
      }
    }
  },

  props: {
    parentId: {required: true },
    variationId: {default: null },
    currency: { type: Object, required: true },
    availsOptions: { type: Array, default: () => [] },
    featuresOptions: { type: Array, default: () => [] },
    closedTabs: { type: Boolean, default: false},

  },

  data() {
    return {
      removedImage: false,
      new_store_for_inventory: null,
      inventories: [],
      inventoriesLoading: false,
      pricingDirty: false,
      pricingSaving: false,
      inventoryDirty: false,
      inventorySaving: false,
      openPanels: {
        basic: true,
        shipping: !this.closedTabs,
        attributes: !this.closedTabs,
        pricing: !this.closedTabs,
        inventory: true,
        details: !this.closedTabs,
      },
      openLabelMenuId: null,

      stores: [],

      form: {
        id: null,
        variation_title: '',
        name: '',
        try_on_color_hex: '', ...tryOnCalibrationFrom(),
        sixteen_digit_code: '',
        status: 'draft',

        // قیمت
        legend_pricing: 'true',
        regular_price: 0,
        price: 0,
        base_price: 0,
        shipping_cost: 0,
        profit_type: 'percent',
        profit_margin: 0,
        discount_type: 'percent',
        discount_margin: 0,

        // ابعاد و وزن
        postal_weight: 0,
        length: 0,
        width: 0,
        height: 0,

        // زمان و مکان
        product_date: null,
        expired_date: null,
        aisle: '',
        shelf_number: '',

        // تصویر
        image: null,

        // دسته‌بندی‌ها
        avails: [],
        feature: [],

        // تنظیمات موجودی پایه
        packing_inventory: {
          store: 1,
          name: 'پردازش',
          inventory: 0,
          minimum_inventory: 0
        }
      }
    }
  },

  filters: {
    toMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('fa-IR');
    }
  },

  computed: {
    pricingButtonClass() {
      if (this.pricingSaving) {
        return 'px-4 py-2 rounded-md bg-gray-400 text-white text-sm cursor-wait opacity-70';
      }
      if (this.pricingDirty) {
        return 'px-4 py-2 rounded-md bg-blue-600 text-white text-sm';
      }
      return 'px-4 py-2 rounded-md   text-green-700 text-sm';
    },
    pricingButtonText() {
      if (this.pricingSaving) return 'در حال ذخیره...';
      if (this.pricingDirty) return 'ذخیره قیمت (تغییرات اعمال نشده)';
      return 'ذخیره شده ✔';
    },

    inventoryButtonClass() {
      if (this.inventorySaving) {
        return 'px-4 py-2 rounded-md bg-gray-400 text-white text-sm cursor-wait opacity-70';
      }
      if (this.inventoryDirty) {
        return 'px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm';
      }
      return 'px-4 py-2 rounded-md bg-green-600 hover:bg-green-700 text-white text-sm';
    },
    inventoryButtonText() {
      if (this.inventorySaving) return 'در حال ذخیره...';
      if (this.inventoryDirty) return 'ذخیره موجودی (تغییرات اعمال نشده)';
      return 'ذخیره شد ✔';
    },

    inventory_store_ids() {
      return (this.inventories || [])
          .map(r => r.store)
          .filter(Boolean)
    },

    has_new_inventory_row() {
      return (this.inventories || []).some(r => r._isNew)
    },

    total_inventory() {
      return (this.inventories || []).reduce(
          (s, r) => s + Number(r._inventoryDraft ?? r.inventory ?? 0),
          0
      )
    },

    // نرخ‌ها
    base_price_with_rate() {
      return (this.currency.exchange_rate_to_toman || 1) * (this.form.base_price || 0)
    },

    shipping_cost_with_rate() {
      return (this.currency.exchange_rate_to_toman || 1) * (this.form.shipping_cost || 0)
    },

    // حاشیه سود به تومان
    profit_sum() {
      if (this.form.profit_type === 'percent') {
        return ((this.base_price_with_rate + this.shipping_cost_with_rate) / 100) * (this.form.profit_margin || 0)
      }
      return (this.form.profit_margin || 0)
    },

    // مقدار تخفیف
    discount_sum() {
      let profitAmount = (this.form.profit_type === 'percent')
          ? (this.base_price_with_rate / 100) * (this.form.profit_margin || 0)
          : (this.form.profit_margin || 0)

      let priceWithProfit = profitAmount + this.base_price_with_rate

      if (this.form.discount_type === 'percent') {
        return (priceWithProfit / 100) * (this.form.discount_margin || 0)
      }
      return (this.form.discount_margin || 0)
    },

    final_amount() {
      let profitAmount = (this.form.profit_type === 'percent')
          ? ((this.base_price_with_rate + this.shipping_cost_with_rate) / 100) * (this.form.profit_margin || 0)
          : (this.form.profit_margin || 0)

      let priceWithProfit = profitAmount + this.base_price_with_rate + this.shipping_cost_with_rate

      let discountAmount = (this.form.discount_type === 'percent')
          ? (priceWithProfit / 100) * (this.form.discount_margin || 0)
          : (this.form.discount_margin || 0)

      return priceWithProfit - discountAmount
    },

    // برای قفل کردن v-model روی cleave-money
    final_amount_local: {
      get() {
        return this.final_amount
      },
      set(_) {
        // read-only
      }
    }
  },

  mounted() {
    this.getStores()
    if (this.variationId) {
      this.fetchVariation(this.variationId)
    }
  },

  methods: {
    onVariationImageChange(payload) {
      this.form.image = payload;
      this.removedImage = false;
    },

    removeVariationImage() {
      this.form.image = null;
      this.removedImage = !!this.form.id;
    },
    toggleLabelMenu(productId) {
      this.openLabelMenuId = this.openLabelMenuId === productId ? null : productId;
    },
    openLabel(productId, mode) {
      const baseUrl = this.endpoint(`product/label/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openQr(productId, mode) {
      const baseUrl = this.endpoint(`product/qrCode/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },

    inventoryRowButtonClass(row) {
      if (row._saving) {
        return 'px-2 py-1 rounded bg-gray-400 text-white text-xs cursor-wait opacity-70';
      }
      if (row._dirty) {
        return 'px-2 py-1 rounded bg-blue-600 text-white text-xs';
      }
      return 'px-2 py-1 rounded bg-green-600 text-white  text-xs';
    },

    inventoryRowButtonText(row) {
      if (row._saving) {
        return 'در حال ذخیره';
      }
      if (row._dirty) {
        return 'ثبت';
      }
      return ' ✔ ';
    },

    // هر تغییری توی فرم قیمت → اینو صدا بزن
    markPricingDirty() {
      this.pricingDirty = true;
    },

    // هر تغییری توی بخش موجودی کلی
    markInventoryDirty() {
      this.inventoryDirty = true;
    },

    // هر تغییری توی یکی از ردیف‌های جدول موجودی
    markInventoryDirtyRow(row) {
      this.$set(row, '_dirty', true);
      this.inventoryDirty = true;
    },

    // ---------------------------
    // UI helpers
    // ---------------------------
    isOpen(key) { return !!this.openPanels[key] },
    togglePanel(key) { this.$set(this.openPanels, key, !this.openPanels[key]) },

    image_source(image) {
      if (!image) return 'https://via.placeholder.com/150'
      if (/^\/media/.test(image)) return this.img_source(image)
      if (typeof image === 'string') return image
      if (image.preview) return image.preview
      if (image.file) return URL.createObjectURL(image.file)
      return 'https://via.placeholder.com/150'
    },

    handleImageUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = (ev) => {
        this.form.image = { file, preview: ev.target.result }
        this.removedImage = false
      }
      reader.readAsDataURL(file)
    },

    handleRemoveImage() {
      this.removedImage = true
      this.form.image = null
    },

    resetForm() {
      this.removedImage = false
      this.pricingDirty = false
      this.pricingSaving = false
      this.inventoryDirty = false
      this.inventorySaving = false

      this.form = {
        id: null,
        variation_title: '',
        name: '',
        try_on_color_hex: '', ...tryOnCalibrationFrom(),
        sixteen_digit_code: '',
        status: 'draft',

        legend_pricing: 'true',
        regular_price: 0,
        price: 0,
        base_price: 0,
        shipping_cost: 0,
        profit_type: 'percent',
        profit_margin: 0,
        discount_type: 'percent',
        discount_margin: 0,

        postal_weight: 0,
        length: 0,
        width: 0,
        height: 0,

        product_date: null,
        expired_date: null,
        aisle: '',
        shelf_number: '',

        image: null,

        avails: [],
        feature: [],

        packing_inventory: {
          store: 1,
          name: 'پردازش',
          inventory: 0,
          minimum_inventory: 0
        }
      }
      this.inventories = []
    },

    fetchVariation(id) {
      this.request({
        url: this.endpoint(`product/v2/adminProductGet/${id}`),
        method: 'get',
        success: (data) => {
          this.form.id = data.id || null
          this.form.variation_title = data.variation_title || ''
          this.form.name = data.name || ''
          this.form.try_on_color_hex = data.try_on_color_hex || '';
          Object.assign(this.form, tryOnCalibrationFrom(data));
          this.form.sixteen_digit_code = data.sixteen_digit_code || ''
          this.form.status = data.status || 'draft'

          // قیمت
          this.form.legend_pricing = 'true'
          this.form.regular_price = data.regular_price || 0
          this.form.price = data.price || 0
          this.form.base_price = data.base_price || 0
          this.form.shipping_cost = data.shipping_cost || 0
          this.form.profit_type = data.profit_type || 'percent'
          this.form.profit_margin = data.profit_margin || 0
          this.form.discount_type = data.discount_type || 'percent'
          this.form.discount_margin = data.discount_margin || 0

          this.form.postal_weight = data.postal_weight || 0
          this.form.length = data.length || 0
          this.form.width = data.width || 0
          this.form.height = data.height || 0

          this.form.product_date = data.product_date || null
          this.form.expired_date = data.expired_date || null
          this.form.aisle = data.aisle || ''
          this.form.shelf_number = data.shelf_number || ''

          this.form.image = data.picture || data.image || null
          this.removedImage = false

          this.form.avails = data.avails || []
          this.form.feature = data.feature || []

          this.pricingDirty = false
          this.inventoryDirty = false

          if (this.form.id) {
            this.loadInventories(this.form.id)
          }
        }
      })
    },

    getStores() {
      this.request({
        url: this.endpoint('main/store'),
        method: 'get',
        success: data => {
          this.stores = []
          for (let store of data) {
            if (store.id !== 1) {
              this.stores.push(store.id)
            }
          }
        }
      })
    },

    loadInventories(productId) {
      if (!productId) return
      this.inventoriesLoading = true

      const tryUrl = this.endpoint(`product/v2/adminInventory?product=${productId}`)
      const fallbackUrl = this.endpoint(`product/v2/adminInventory`)

      const onSuccess = (rows) => {
        const list = (rows || []).filter(x => x.product === productId)
        this.inventories = list.map(x => ({
          ...x,
          _key: x.id || `${x.product}-${x.store}`,
          _isNew: false,
          _saving: false,
          _dirty: false,
          _inventoryDraft: Number(x.inventory || 0)
        }))
        this.inventoriesLoading = false
      }

      this.request({
        url: tryUrl,
        method: 'get',
        success: onSuccess,
        error: () => {
          this.request({
            url: fallbackUrl,
            method: 'get',
            success: onSuccess,
            finally: () => { this.inventoriesLoading = false }
          })
        },
        finally: () => { this.inventoriesLoading = false }
      })
    },

    addInventoryRow() {
      this.inventoryDirty = true
      this.inventories.push({
        _key: `new-${Date.now()}`,
        _isNew: true,
        _saving: false,
        _dirty: true,
        product: this.form.id || null,
        store: null,
        store_name: null,
        inventory: 0,
        _inventoryDraft: 0
      })
    },

    removeNewRow(row) {
      const i = this.inventories.indexOf(row)
      if (i >= 0) this.inventories.splice(i, 1)
      this.inventoryDirty = true
    },

    canSaveRow(row) {
      if (row._isNew) {
        return !!this.new_store_for_inventory && row._inventoryDraft >= 0
      }
      return true
    },

    saveInventoryRow(row) {
      if (!this.canSaveRow(row)) return
      row._saving = true

      if (row._isNew) {
        this.request({
          url: this.endpoint('product/v2/adminInventory'),
          method: 'post',
          data: {
            product: this.form.id,
            store: this.new_store_for_inventory,
            inventory: Number(row._inventoryDraft || 0)
          },
          success: (created) => {
            const i = this.inventories.indexOf(row)
            const normalized = {
              ...created,
              _key: created.id || `${created.product}-${created.store}`,
              _isNew: false,
              _saving: false,
              _dirty: false,
              _inventoryDraft: Number(created.inventory || 0)
            }
            if (i >= 0) this.inventories.splice(i, 1, normalized)
            this.successNotify('موجودی انبار ایجاد شد')
            this.$emit('changed')
            this.new_store_for_inventory = null
            this.inventoryDirty = false
            row._saving = false
          },
          finally: () => { row._saving = false }
        })
      } else if (row.id) {
        this.request({
          url: this.endpoint(`product/v2/adminInventory/${row.id}`),
          method: 'patch',
          data: {
            inventory: Number(row._inventoryDraft || 0),
            product: row.product,
            store: row.store
          },
          success: () => {
            row.inventory = Number(row._inventoryDraft || 0)
            row._dirty = false
            this.successNotify('موجودی انبار به‌روزرسانی شد')
            row._saving = false

            this.inventoryDirty = this.inventories.some(r => r._dirty || r._isNew)
          },
          error: () => {
            row._inventoryDraft = Number(row.inventory || 0)
            this.deleteNotify('خطا در به‌روزرسانی', 'خطا در به‌روزرسانی موجودی')

          },
          finally: () => { row._saving = false }
        })
      } else {
        row._saving = false
      }
    },

    saveVariationCore() {
      if (!validTryOnCalibration(this.form)) {
        window.alert('شدت و پوشانندگی باید بین ۰ و ۱، و روشنایی بین ۰٫۵ و ۱٫۵ باشند.');
        return;
      }
      if (this.form.try_on_color_hex && !/^#[0-9a-f]{6}$/i.test(this.form.try_on_color_hex)) {
        window.alert('کد رنگ باید به شکل #RRGGBB باشد.');
        return;
      }

      if (!this.form.name || !this.form.sixteen_digit_code) {
        window.alert('نام و SKU نباید خالی باشند')
        return
      }

      const fd = new FormData()

      if (!this.form.id) {
        fd.append('variation_of', this.parentId)
      }

      fd.append('try_on_color_hex', this.form.try_on_color_hex || '');

      appendTryOnCalibration(fd, this.form);
      fd.append('name', this.form.name || '')
      fd.append('sixteen_digit_code', this.form.sixteen_digit_code || '')
      fd.append('status', this.form.status || 'draft')

      fd.append('postal_weight', this.form.postal_weight || 0)
      fd.append('length', this.form.length || 0)
      fd.append('width', this.form.width || 0)
      fd.append('height', this.form.height || 0)

      fd.append('product_date', this.form.product_date || '')
      fd.append('expired_date', this.form.expired_date || '')

      fd.append('aisle', this.form.aisle || '')
      fd.append('shelf_number', this.form.shelf_number || '')

      const avIds = (this.form.avails || []).map(a => a.id)
      const featIds = (this.form.feature || []).map(f => f.id)
      avIds.forEach(id => fd.append('avails_ids', id))
      featIds.forEach(id => fd.append('features_ids', id))

      if (this.removedImage === true) {
        fd.append('remove_image', 'true')
      } else if (this.form.image && this.form.image.file) {
        fd.append('image', this.form.image.file)
        fd.append('remove_image', 'false')
      } else if (typeof this.form.image === 'string') {
        fd.append('remove_image', 'false')
      }

      const isEdit = !!this.form.id
      const url = isEdit
          ? this.endpoint(`product/v2/adminVariationUpdate/${this.form.id}`)
          : this.endpoint('product/v2/adminVariationCreate')

      const method = isEdit ? 'put' : 'post'

      this.request({
        url,
        method,
        data: fd,
        headers: { 'Content-Type': 'multipart/form-data' },
        success: (variationResponse) => {
          this.form.id = variationResponse.id
          this.successNotify('مشخصات متغیر ذخیره شد')
          this.$emit('saved', variationResponse)
          this.$emit('changed')
          this.loadInventories(this.form.id)
        },
        error: (err) => {
          this.deleteNotify('خطا ', 'خطا در ذخیره متغیر')
        }
      })
    },

    savePricing() {
      if (!this.form.id) return

      this.pricingSaving = true

      const sendRegular = this.form.regular_price
      const sendPrice = this.form.price

      this.request({
        url: this.endpoint(`product/v2/adminProductPricingUpdate/${this.form.id}`),
        method: 'put',
        data: {
          regular_price: this.form.regular_price,
          price: this.form.price,
          legend_pricing: true,
          base_price: this.form.base_price,
          profit_type: this.form.profit_type,
          profit_margin: this.form.profit_margin,
          discount_type: this.form.discount_type,
          discount_margin: this.form.discount_margin,
          shipping_cost: this.form.shipping_cost,
        },
        success: (priceResp) => {
          this.form.regular_price = priceResp.regular_price ?? sendRegular
          this.form.price = priceResp.price ?? sendPrice
          this.successNotify('قیمت ذخیره شد')
          this.$emit('changed')
          this.pricingDirty = false
          this.pricingSaving = false
        },
        error: (err) => {
          console.error('price save error', err)
          this.deleteNotify('خطا ', 'خطا در ذخیره قیمت')

          this.pricingSaving = false
        },
        finally: () => {
          this.pricingSaving = false
        }
      })
    }
  }
}
</script>

<style scoped>
.form-input {
  @apply w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200;
}

.select-wrap {
  @apply relative;
}

.select-input {
  color: #111827;
  background-image: none;
  line-height: 1.5rem;
  padding: 5px;
  border-radius: 0.375rem;
  background-color: rgba(239, 246, 255, 0.8);
  text-align: center;
}

.q-wrapper .ql-editor {
  text-align: right;
}

.q-wrapper {
  background: #fff;
  border-radius: 20px;
}


.select-wrap svg {
  z-index: 1;
}

.select-label {
  z-index: 9999999;
}


.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .2s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
.group:hover .group-hover\:scale-105 {
  transform: scale(1.05);
}

.shadow-lg {
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2);
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
</style>
